import { useCallback, useMemo } from 'react';
import { useRemotionPlayerCurrentTime } from '../ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerCurrentTime';
import { useRemotionPlayerPause } from '../ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerPause';
import { useRemotionPlayerSeek } from '../ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerSeek';
import useRemotionPlayerDuration from '../ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerDuration';
import PlayPause from '@/components/molecules/PlayPause';
import ProgressBarSection from '@/Pages/Clip/ClipPlayer/ClipPlayerControls/ProgressBarSection';
import { formatTime } from '@/libs/core';

const ClipPlayerControlsV2 = () => {
  const { isPlaying, play, pause } = useRemotionPlayerPause();

  const { currentTime: currentExactSeconds } = useRemotionPlayerCurrentTime();

  const { seekTo } = useRemotionPlayerSeek();

  const currentIntegerSeconds = useMemo(() => {
    return Math.floor(currentExactSeconds);
  }, [currentExactSeconds]);

  const clipDuration = useRemotionPlayerDuration();

  const onSeeked = useCallback(
    (time: number) => {
      seekTo(time);
      // if before seeking video was playing, then play after seek as well
      if (isPlaying) {
        play();
      }
    },
    [seekTo, play, isPlaying]
  );

  return (
    <div className="flex w-full items-center justify-between bg-white px-3 py-2">
      <div />
      <div className="mx-auto flex w-full max-w-screen-md items-center gap-0.5">
        <PlayPause paused={!isPlaying} onPlay={play} onPause={pause} disabled={false} />
        <span className="w-[38px] select-none text-center text-[10px] text-slate-400">
          {formatTime(currentIntegerSeconds)}
        </span>
        <div className="flex w-full">
          <ProgressBarSection
            section="main"
            duration={clipDuration}
            totalDuration={clipDuration}
            currentTime={currentExactSeconds}
            status={'current'}
            disabled={false}
            onSeeked={onSeeked}
          />
        </div>
        <span className="w-[38px] select-none text-center text-[10px] text-slate-400">{formatTime(clipDuration)}</span>
      </div>
    </div>
  );
};

export default ClipPlayerControlsV2;
